import React, { useState, useRef, useEffect } from "react";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import Modal1 from "../DIsplay/Modal/Modal1";
import CommonFreeTextInput from "../common/inputs/CommonFreeTextInput";
import getAccounts from "../../controllers/user/getAccounts";
import CommonSearchableDropdownInput from "../common/inputs/CommonSearchableDropdownInput";
import importPnr, { saveImportedPnr } from "../../controllers/Flight/importPnr";
import { enqueueSnackbar } from "notistack";
import BookingConfirmationFlightDetails from "../../pages/TicketManagement/Flight/Booking/BookingConfirmationFlightDetails";
import { Passengers } from "../../pages/TicketManagement/Flight/OrderDetail/Passengers";

function ImportPNR() {
  const [modal, setModal] = useState(false);
  const [pnr, setPnr] = useState("");
  const [agent, setAgent] = useState("");
  const [agents, setAgents] = useState([]);
  const [agentSearch, setAgentSearch] = useState("");
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const cancelRef = useRef(null);
  const [importedModal, setImportedModal] = useState();
  const [importedPNR, setImportedPNR] = useState(null);

  const handleClose = () => {
    setModal(false);
    setPnr("");
    setAgent("");
    setAgents([]);
    setAgentSearch("");
    setImportedModal(false);
    setImportedPNR(null);
  };

  const handleImport = async () => {
    setLoading(true);

    const res = await importPnr({
      agentAccountId: agent,
      supplier: "AmadeusTwo",
      pnrOrOrderId: pnr,
    }).finally(() => setLoading(false));

    if (res?.return) {
      // enqueueSnackbar("PNR imported successfully!", { variant: "success" });
      setImportedPNR(res?.data);
      setModal(false);
      setImportedModal(true);

      // setTimeout(() => {
      //   window.location.reload();
      // }, 300);
    } else {
      enqueueSnackbar(
        res?.data?.message || "Failed to import PNR. Please try again.",
        { variant: "error" }
      );
    }
  };

  const handleSaveImported = async () => {
    setLoading(true);

    const res = await saveImportedPnr({
      agentAccountId: agent,
      supplier: "AmadeusTwo",
      pnrOrOrderId: pnr,
    }).finally(() => setLoading(false));

    if (res?.return) {
      enqueueSnackbar("PNR imported successfully!", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else {
      enqueueSnackbar(
        res?.data?.message || "Failed to import PNR. Please try again.",
        { variant: "error" }
      );
    }
  };

  const isDisabled = !pnr?.trim() || !agent;

  const loadAgents = async () => {
    if (!modal) return;

    const params = {
      limit: 50,
      searchBy:
        "firstName,lastName,email,phone,detail.agencyName,detail.companyName,detail.tradingName",
      keyword: agentSearch,
    };

    // cancel previous request if any
    if (cancelRef.current) {
      cancelRef.current.cancel("Operation canceled due to new request.");
    }
    cancelRef.current = axios.CancelToken.source();

    setAgentsLoading(true);
    const res = await getAccounts(
      new URLSearchParams(params)?.toString(),
      cancelRef.current.token
    );
    setAgentsLoading(false);

    if (res?.return) {
      const data = res?.data?.data || [];
      setAgents(
        data.map((agent) => {
          const name = [agent?.firstName, agent?.lastName]
            .filter(Boolean)
            .join(" ");

          return {
            ...agent,
            code: agent?._id,
            label: name || agent?.email || "Unnamed agent",
            description: agent?.detail?.tradingName,
          };
        })
      );
    }
  };

  useEffect(() => {
    loadAgents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentSearch, modal]);

  const agentOptions = agents;

  return (
    <div className="w-fit">
      <button
        onClick={() => {
          setModal(true);
          setPnr("");
          setAgent("");
          setAgentSearch("");
        }}
        className="
          flex items-center gap-2
          whitespace-nowrap
          px-3 py-1.5
          bg-blue-600 text-white 
          text-sm font-medium 
          rounded-md 
          shadow-sm
          hover:bg-blue-700 
          active:scale-[0.98]
          transition-all h-10
        "
      >
        <FiUpload className="text-base" />
        Import PNR
      </button>

      <Modal1 open={modal} setOpen={setModal}>
        <div className="w-full max-w-md p-6">
          {/* Header */}
          <div className="flex items-start justify-between gap-4 mb-4">
            <div>
              <h2 className="text-base font-semibold text-gray-900">
                Import PNR
              </h2>
              <p className="mt-1 text-xs text-gray-500">
                Paste the airline PNR and select an agent to attach this booking
                to.
              </p>
            </div>
          </div>

          {/* PNR Input */}
          {/* Agent dropdown */}
          <div className="mt-4">
            <CommonSearchableDropdownInput
              label="Assign to agent"
              placeholder="Search by agent name, email, or phone"
              value={agent}
              onChange={(value) => {
                setAgent(value);
                // const selected = agentOptions.find(
                //   (val) => val?.code === value
                // );
                // setAgentSearch(selected?.label || "");
              }}
              options={agentOptions}
              search={agentSearch}
              onSearchChange={setAgentSearch}
              loading={agentsLoading}
              onOpen={setDropdownOpen}
            />
          </div>
          <div className="mt-3">
            <CommonFreeTextInput
              label="PNR"
              placeholder="e.g. AB12CD"
              value={pnr}
              onChange={setPnr}
            />
            <p className="mt-1 text-[11px] text-gray-400">
              PNRs are usually 6 characters (letters and/or numbers).
            </p>
          </div>

          {/* Footer actions */}
          <div className="mt-20 flex justify-end gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="
                px-3 py-1.5
                text-sm font-medium
                rounded-md
                border border-gray-300
                text-gray-700
                hover:bg-gray-50
                transition-colors
              "
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleImport}
              disabled={isDisabled}
              className={`
                h-12 w-32 flex items-center justify-center
                text-sm font-medium
                rounded-md
                text-white
                bg-blue-600
                hover:bg-blue-700
                transition-colors
                disabled:bg-gray-300
                disabled:cursor-not-allowed
              `}
            >
              {loading ? <div className="buttonLoader"></div> : <>Import PNR</>}
            </button>
          </div>
        </div>
      </Modal1>
      <Modal1 open={importedModal} setOpen={setImportedModal}>
        <div className="w-full max-w-5xl p-6 max-h-[90vh] overflow-scroll scroll-hide">
          {/* Header */}
          <div className="flex items-start justify-between gap-4 mb-4">
            <div>
              <h1 className="text-base font-semibold text-gray-900">
                Import PNR
              </h1>
            </div>
          </div>

          {/* PNR Input */}
          {/* Agent dropdown */}
          <BookingConfirmationFlightDetails
            data={{
              flightBooking: importedPNR,
            }}
          />
          <Passengers
            order={{
              booking: {
                flightBooking: [importedPNR],
              },
            }}
            noEdit
          />

          {/* Footer actions */}
          <div className="mt-20 flex justify-end gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="
                px-3 py-1.5
                text-sm font-medium
                rounded-md
                border border-gray-300
                text-gray-700
                hover:bg-gray-50
                transition-colors
              "
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSaveImported}
              disabled={isDisabled}
              className={`
                h-12 w-32 flex items-center justify-center
                text-sm font-medium
                rounded-md
                text-white
                bg-blue-600
                hover:bg-blue-700
                transition-colors
                disabled:bg-gray-300
                disabled:cursor-not-allowed
              `}
            >
              {loading ? <div className="buttonLoader"></div> : <>Save PNR</>}
            </button>
          </div>
        </div>
      </Modal1>
    </div>
  );
}

export default ImportPNR;
